"use strict";

exports.__esModule = true;
exports.PLUGINS = void 0;
var PLUGINS = {
  IMAGE: 'image',
  VIDEO: 'video',
  FILE_UPLOAD: 'wix-draft-plugin-file-upload',
  LINK: 'link',
  HASHTAG: 'hashtag',
  DIVIDER: 'divider',
  HTML: 'html',
  MENTIONS: 'mentions',
  CODE_BLOCK: 'code_block',
  TEXT_COLOR: 'wix-rich-content-text-color',
  GIPHY: 'wix-draft-plugin-giphy',
  EMOJI: 'EMOJI_TYPE',
  LINK_PREVIEW: 'LINK_PREVIEW'
};
exports.PLUGINS = PLUGINS;